import { render } from "./ResetPwd.vue?vue&type=template&id=63ffb6a8&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"

import "./ResetPwd.vue?vue&type=style&index=0&id=63ffb6a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ffb6a8"]])

export default __exports__